"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.findUSTimezoneRegion = void 0;
const findUSTimezoneRegion = (state) => {
    const stateLower = state.toLowerCase();
    switch (stateLower) {
        case 'connecticut':
        case 'delaware':
        case 'district of columbia':
        case 'florida':
        case 'georgia':
        case 'indiana':
        case 'maine':
        case 'maryland':
        case 'massachusetts':
        case 'michigan':
        case 'new hampshire':
        case 'new jersey':
        case 'new york':
        case 'north carolina':
        case 'ohio':
        case 'pennsylvania':
        case 'rhode island':
        case 'south carolina':
        case 'vermont':
        case 'virginia':
        case 'west virginia':
            return 'EST';
        case 'arizona':
        case 'colorado':
        case 'idaho':
        case 'montana':
        case 'new mexico':
        case 'utah':
            return 'MST';
        case 'alabama':
        case 'arkansas':
        case 'illinois':
        case 'iowa':
        case 'kansas':
        case 'kentucky':
        case 'louisiana':
        case 'minnesota':
        case 'mississippi':
        case 'missouri':
        case 'nebraska':
        case 'north dakota':
        case 'oklahoma':
        case 'south dakota':
        case 'tennessee':
        case 'texas':
        case 'wisconsin':
            return 'CST';
        case 'american samoa':
        case 'alaska':
        case 'aleutian islands':
        case 'california':
        case 'guam':
        case 'hawaii':
        case 'nevada':
        case 'northern mariana islands':
        case 'oregon':
        case 'puerto rico':
        case 'united states virgin islands':
        case 'washington':
        case 'wyoming':
        default:
            return 'PST';
    }
};
exports.findUSTimezoneRegion = findUSTimezoneRegion;
